import axios from "axios";
import {
  clearUserData,
  setAuthenticationState,
} from "../../redux/dispatchers/users.dispatcher";

export const BASE_URL = `${process.env.REACT_APP_PROD_BASE_URL}/api`;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

let dispatch;

export const setFunctions = (dispatchFunction) => {
  dispatch = dispatchFunction;
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("Interceptor caught error:", error, error?.response?.status);

    if (error.response && error.response.status === 401) {
      console.log("Triggering dispatch for 401");

      if (dispatch) {
        dispatch(setAuthenticationState(false));
        dispatch(clearUserData());
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
